import { motion } from "framer-motion";
import { Camera } from "lucide-react";

// Zodyak halkası: 12 işaret noktası
export const ZodiacRing = ({ className = "" }) => (
  <svg viewBox="0 0 200 200" className={className} fill="none">
    <circle cx="100" cy="100" r="96" stroke="rgba(212,175,55,0.35)" strokeWidth="0.6" />
    <circle cx="100" cy="100" r="78" stroke="rgba(212,175,55,0.2)" strokeWidth="0.4" strokeDasharray="2 5" />
    {Array.from({ length: 12 }).map((_, i) => {
      const a = (i * 30 * Math.PI) / 180;
      const x1 = 100 + 84 * Math.cos(a);
      const y1 = 100 + 84 * Math.sin(a);
      const x2 = 100 + 96 * Math.cos(a);
      const y2 = 100 + 96 * Math.sin(a);
      const cx = 100 + 70 * Math.cos(a + Math.PI / 12);
      const cy = 100 + 70 * Math.sin(a + Math.PI / 12);
      return (
        <g key={i}>
          <line x1={x1} y1={y1} x2={x2} y2={y2} stroke="rgba(212,175,55,0.6)" strokeWidth="0.8" />
          <circle cx={cx} cy={cy} r="1.4" fill="rgba(212,175,55,0.7)" />
        </g>
      );
    })}
  </svg>
);

// Hilal
const Crescent = ({ className = "" }) => (
  <svg viewBox="0 0 100 100" className={className} fill="none">
    <path
      d="M62 12a40 40 0 1 0 0 76 34 34 0 0 1 0-76z"
      fill="url(#cg)"
    />
    <defs>
      <linearGradient id="cg" x1="0" y1="0" x2="100" y2="100">
        <stop offset="0%" stopColor="#E5C158" />
        <stop offset="100%" stopColor="#8a6d1f" />
      </linearGradient>
    </defs>
  </svg>
);

const PortraitFrame = ({ src, arch = true, alt = "Astrolog portresi", testId }) => {
  const rounded = arch ? "rounded-t-[999px] rounded-b-2xl" : "rounded-2xl";
  return (
    <div className={`relative ${rounded} border border-gold/40 p-2 sm:p-3`} data-testid={testId}>
      <div className={`relative overflow-hidden ${rounded} bg-navy-800 aspect-[3/4]`}>
        {src ? (
          <img
            src={src}
            alt={alt}
            className="h-full w-full object-cover"
            style={{ objectPosition: "center 22%" }}
          />
        ) : (
          <div className="relative h-full w-full flex items-center justify-center bg-[radial-gradient(circle_at_50%_30%,#1B2A4A_0%,#0B1325_75%)]">
            <motion.div
              className="absolute inset-[-20%]"
              animate={{ rotate: 360 }}
              transition={{ duration: 90, repeat: Infinity, ease: "linear" }}
            >
              <ZodiacRing className="h-full w-full opacity-70" />
            </motion.div>
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 1.6, delay: 0.6 }}
              className="relative"
            >
              <Crescent className="w-20 h-20 sm:w-24 sm:h-24 drop-shadow-[0_0_25px_rgba(212,175,55,0.4)]" />
            </motion.div>
            <div className="absolute bottom-5 inset-x-0 flex justify-center">
              <span className="inline-flex items-center gap-2 rounded-full border border-gold/30 bg-navy/70 px-4 py-1.5 text-[11px] font-mono tracking-wider text-gold/90 backdrop-blur-sm">
                <Camera className="w-3.5 h-3.5" />
                Fotoğrafınız buraya eklenecek
              </span>
            </div>
          </div>
        )}
      </div>
      <div className="absolute -top-2 -left-2 h-6 w-6 border-t border-l border-gold" />
      <div className="absolute -bottom-2 -right-2 h-6 w-6 border-b border-r border-gold" />
    </div>
  );
};

export default PortraitFrame;
